import React, { useCallback, useEffect, useRef, useState } from "react";
import { BiText } from "react-icons/bi";
import { RiTextSpacing } from "react-icons/ri";
import {
  MdOutlineDescription,
  MdPersonOutline,
  MdOutlineFilterFrames,
  MdBorderOuter,
  MdOutlinePanoramaVertical,
  MdOutlinePanoramaHorizontal,
  MdTextRotationNone,
} from "react-icons/md";
import { BsCardImage } from "react-icons/bs";
import { AiOutlineStar, AiOutlineFileImage } from "react-icons/ai";

import classes from "./Card1Page.module.css";
import Card1 from "../../stories/card1/Card1";
import Header from "../../stories/Header";
import PopOverItem from "../../stories/PopOverItem/PopOverItem";
import TextPopOverchildren from "../../stories/TextPopOverchildren/TextPopOverchildren";
import {
  auntySvg,
  border1,
  goldenFrame,
  silverHorizontalstrip,
  silverStar,
  silverTitleBg,
  silverVerticleStrip,
  subTitleBlackBg,
} from "../../assets/images/imagePath";
import {
  borderImages,
  dataURLtoFile,
  frameImages,
  horizontalStripImages,
  resizeFile,
  starImages,
  titleBgImages,
  verticalStripImages,
  _description,
} from "../../handlers/helperFunctions";
import BgImagePopoverChildren from "../../stories/BgImagePopoverChildren";
import FramePopOverChildren from "../../stories/FramePopOverChildren/FramePopOverChildren";
import Button from "../../stories/Button/Button";
import ConfirmationModal from "../../stories/Confirmation/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import { toJpeg } from "html-to-image";
import { toast } from "react-toastify";
import { Sleep } from "../../config/apiUrl";
import BodyLoader from "../../stories/BodyLoader/BodyLoader";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { saveLocation } from "../../redux/common/commonSlice";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";

const Card1Page = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);

  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    dispatch(saveLocation(location));
  }, []);

  const navigate = useNavigate();
  const imageRef = useRef();
  const backImageRef = useRef();
  const [generatedImages, setGeneratedImages] = useState({
    front: null,
    back: null,
  });
  const [isGeneratingPreview, setIsGeneratingPreview] = useState(false);

  const [mainBg, setMainBg] = useState(auntySvg);

  const [title, setTitle] = useState({
    url: silverTitleBg,
    text: "Lorem ipsum dolor",
    isVisible: true,
    color: "#000",
    fontStyle: null,
    fontWeight: null,
  });

  const [subTitle, setSubTitle] = useState({
    url: subTitleBlackBg,
    text: "Lorem ipsum dolor",
    isVisible: true,
    color: "#fff",
    fontStyle: null,
    fontWeight: null,
  });

  const [description, setDescription] = useState({
    text: _description,
    isVisible: true,
    color: "#000",
    transparency: "0.2",
    blur: "5px",
    outline: "0.3",
    bgColor: "rgb(255, 255, 255)",
    fontStyle: null,
    fontWeight: null,
  });

  const [createdBy, setCreatedBy] = useState({
    text: "John Doe",
    isVisible: true,
    color: "#000",
    fontStyle: null,
    fontWeight: null,
  });

  const [frame, setFrame] = useState({
    url: goldenFrame,
    isVisible: true,
  });

  const [border, setBorder] = useState({
    url: border1,
    isVisible: true,
  });

  const [horizontalStrip, setHorizontalStrip] = useState({
    url: silverHorizontalstrip,
    isVisible: true,
  });
  const [verticalStrip, setVerticalStrip] = useState({
    isVisible: true,
    url: silverVerticleStrip,
  });

  const [star, setStar] = useState({
    url: silverStar,
    count: 5,
    isVisible: true,
  });

  const [bottomStripText, setBottomStripText] = useState({
    text: "Lorem ipsum",
    isVisible: true,
    color: "#fff",
    fontStyle: null,
    fontWeight: null,
  });

  const [cardBacksideImg, setCardBacksideImg] = useState(auntySvg);

  const [isFrontView, setIsFrontView] = useState(true);

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  // handleGoForward
  const handleGoForward = async () => {
    setIsGeneratingPreview(true);
    const front = await handleGenerateForegroundImage();
    const back = await handleGenerateBackImage();
    setIsGeneratingPreview(false);

    if (!front || !back) return toast.warn("Back or front image is missing.");

    setIsGeneratingPreview(true);

    const _front = await resizeFile(front);
    const _back = await resizeFile(back);
    setIsGeneratingPreview(false);
    navigate("/detail-form", { state: { front: _front, back: _back } });
  };

  // generate image
  const handleGenerateImage = useCallback(async () => {
    if (imageRef.current) {
      await Sleep(1000);
      const code = await toJpeg(imageRef.current);
      let generatedFile = dataURLtoFile(code);

      if (!isFrontView)
        setGeneratedImages((p) => ({ ...p, front: generatedFile }));
      if (isFrontView)
        setGeneratedImages((p) => ({ ...p, back: generatedFile }));
    }
  }, [imageRef?.current]);

  // handleGenerateForegroundImage
  const handleGenerateForegroundImage = useCallback(async () => {
    if (imageRef.current) {
      await Sleep(1000);
      const code = await toJpeg(imageRef.current);
      let generatedFile = dataURLtoFile(code);

      setGeneratedImages((p) => ({ ...p, front: generatedFile }));
      return generatedFile;
    }
  }, [imageRef?.current]);

  // handleGenerateForegroundImage
  const handleGenerateBackImage = useCallback(async () => {
    if (backImageRef.current) {
      await Sleep(1000);
      const code = await toJpeg(backImageRef.current);
      let generatedFile = dataURLtoFile(code);
      setGeneratedImages((p) => ({ ...p, back: generatedFile }));
      return generatedFile;
    }
  }, [backImageRef?.current]);

  return (
    <div>
      <Header />

      {!isMobile && (
        <div className={classes?.splitterContainer}>
          <div className={classes?.leftSplit}>
            {/* Title */}
            <PopOverItem
              Icon={BiText}
              text={"Add Title"}
              identifier={"title"}
              Component={
                <TextPopOverchildren
                  label={"Title"}
                  getter={title}
                  setter={setTitle}
                  galleryArray={titleBgImages}
                />
              }
            />
            {/* Main Img */}
            <PopOverItem
              Icon={BsCardImage}
              text={"Add Image"}
              identifier={"main-bg"}
              Component={<BgImagePopoverChildren setMainBg={setMainBg} />}
            />
            {/* Sub title */}
            <PopOverItem
              label={"Subtitle"}
              Icon={RiTextSpacing}
              text={"Subtitle"}
              identifier={"sub-title"}
              Component={
                <TextPopOverchildren getter={subTitle} setter={setSubTitle} />
              }
            />
            {/* description */}
            <PopOverItem
              Icon={MdOutlineDescription}
              text={"Description"}
              identifier={"description"}
              Component={
                <TextPopOverchildren
                  isDescription={true}
                  label={"Description"}
                  getter={description}
                  setter={setDescription}
                  bgEditable={true}
                />
              }
            />
            {/* createdBy */}
            <PopOverItem
              Icon={MdPersonOutline}
              text={"Created By"}
              identifier={"author"}
              Component={
                <TextPopOverchildren
                  label={"Created By"}
                  getter={createdBy}
                  setter={setCreatedBy}
                />
              }
            />
            {/* Frame */}
            <PopOverItem
              Icon={MdOutlineFilterFrames}
              text={"Add Frame"}
              identifier={"frame"}
              Component={
                <FramePopOverChildren
                  label={"Frame"}
                  getter={frame}
                  setter={setFrame}
                  galleryArray={frameImages}
                />
              }
            />
            {/* Border */}
            <PopOverItem
              Icon={MdBorderOuter}
              text={"Add Border"}
              identifier={"border"}
              Component={
                <FramePopOverChildren
                  label={"Border"}
                  getter={border}
                  setter={setBorder}
                  galleryArray={borderImages}
                />
              }
            />
            {/* Horizontal Strip */}
            <PopOverItem
              Icon={MdOutlinePanoramaHorizontal}
              text={"Add Horizontal Tab"}
              identifier={"horizontal-strip"}
              Component={
                <FramePopOverChildren
                  label={"Horizontal Tab"}
                  getter={horizontalStrip}
                  setter={setHorizontalStrip}
                  galleryArray={horizontalStripImages}
                  sm={true}
                />
              }
            />
            {/* Verticle Strip */}
            <PopOverItem
              Icon={MdOutlinePanoramaVertical}
              text={"Add Vertical Tab"}
              identifier={"verticalStrip"}
              Component={
                <FramePopOverChildren
                  label={"Vertical Tab"}
                  getter={verticalStrip}
                  setter={setVerticalStrip}
                  galleryArray={verticalStripImages}
                  sm={true}
                  main_div_flex={true}
                />
              }
            />
            {/* Star */}
            <PopOverItem
              Icon={AiOutlineStar}
              text={"Add Star"}
              identifier={"star"}
              Component={
                <FramePopOverChildren
                  label={"Star"}
                  getter={star}
                  setter={setStar}
                  galleryArray={starImages}
                  sm={true}
                  main_div_flex={true}
                  star={true}
                />
              }
            />
            {/* Bottom Strip Text */}
            <PopOverItem
              Icon={MdTextRotationNone}
              text={"Horizontal Tab Text"}
              identifier={"author"}
              Component={
                <TextPopOverchildren
                  label={"Horizontal Tab Text"}
                  getter={bottomStripText}
                  setter={setBottomStripText}
                />
              }
            />
            {/* Card Backside */}
            <PopOverItem
              Icon={AiOutlineFileImage}
              text={"Card Back Image"}
              identifier={"back-img"}
              Component={
                <BgImagePopoverChildren setMainBg={setCardBacksideImg} />
              }
            />
          </div>
          <div className={classes?.middleSplit}>
            <Card1
              title={title}
              mainBg={mainBg}
              subTitle={subTitle}
              description={description}
              createdBy={createdBy}
              frame={frame}
              border={border}
              horizontalStrip={horizontalStrip}
              verticalStrip={verticalStrip}
              star={star}
              bottomStripText={bottomStripText}
              cardBacksideImg={cardBacksideImg}
              isFrontView={isFrontView}
              imageRef={imageRef}
              backImageRef={backImageRef}
              generatingPreview={isGeneratingPreview}
            />

            <Button
              label={isFrontView ? "Show Back" : "Show Front"}
              className={classes?.viewtypeBtn}
              onClick={() => {
                // handleGenerateImage();
                setIsFrontView((p) => !p);
              }}
            />

            <Button
              label={"Finish Editing"}
              className={classes?.finishTypeBtn}
              onClick={() => setIsConfirmationModalOpen(true)}
              // onClick={async () => {
              //   setIsGeneratingPreview(true);
              //   await handleGenerateForegroundImage();
              //   await handleGenerateBackImage();
              //   setIsGeneratingPreview(false);
              // }}
            />
          </div>
          <div className={classes?.rightSplit}></div>
        </div>
      )}

      {isMobile && (
        <div className="mobile-rest">
          <p>This page is only supported on desktop devices.</p>
        </div>
      )}

      <ConfirmationModal
        show={isConfirmationModalOpen}
        setShow={setIsConfirmationModalOpen}
        subTitle={`Are you sure you are done editing? Once submitted, you can no longer make any more changes.`}
        onClick={handleGoForward}
      />

      {isGeneratingPreview && <BodyLoader title="Please Wait..." />}
    </div>
  );
};

export default Card1Page;
